import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Bed = (props: Icon): React.ReactElement => {
  if (props.variant === "line") {
    return (
      <svg
        viewBox="0 0 24 22"
        style={{ ...style(props.size, props.height), ...props.style }}
        className={props.className}
      >
        <g
          stroke={props.color || theme.palette.grey600}
          strokeWidth={2}
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2 10V3a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v7" />
          <path d="M12 10V8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2.292M12 10V8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2.292M1 21v-3h22v3" />
          <path d="M1 18v-6a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v6" />
        </g>
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 22"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M.001 20.501a1.5 1.5 0 0 0 3 0v-.5h18v.5a1.5 1.5 0 0 0 3 0v-3.5h-24v3.5zm3-14.5c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v1h2v-5a2 2 0 0 0-2-2h-18a2 2 0 0 0-2 2v5h2v-1zm19 3h-20a2 2 0 0 0-2 2v4h24v-4a2 2 0 0 0-2-2z"
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
      />
    </svg>
  );
};
